<template>
  <el-dialog
    :title="formDialogOptions.dialogTitle"
    :visible.sync="btnRelateDialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    v-draggable
    :width="formDialogOptions.dialogWidth ? formatterWidthOrHeightStyle(formDialogOptions.dialogWidth) : '1200px'"
  >
    <div
      :style="{
        height: formDialogOptions.dialogHeight ? formatterWidthOrHeightStyle(formDialogOptions.dialogHeight) : '650px',
        overflow: 'auto',
        width: `calc(${formDialogOptions.dialogWidth ? formatterWidthOrHeightStyle(formDialogOptions.dialogWidth) : '1200px'} - '40px')`,
      }"
    >
      <VFRuntime
        ref="VFRuntime"
        :primaryKeyValue="formOptions.primaryKeyValue"
        :isDisabled="formOptions.onlyRead"
        :hasSubmit="false"
        :formId="formOptions.formId"
        @submit="onSubmit"
        @cancel="expose_hideDialog"
      ></VFRuntime>
    </div>
    <span slot="footer">
      <el-button type="primary" size="small" @click="submitForm"> 提 交 </el-button>
      <el-button size="small" @click="handleCancel"> 取 消 </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    formDialogOptions: Object,
  },
  data() {
    return {
      btnRelateDialogVisible: false,
      formOptions: {},
      curDialogCompRef: "VFRuntime",
    };
  },
  methods: {
    openDialog(data) {
      this.btnRelateDialogVisible = true;
      this.formOptions = data;
    },
    handleCancel() {
      this.$refs[this.curDialogCompRef]?.handleCancel();
    },
    submitForm() {
      this.$refs[this.curDialogCompRef]?.submitForm();
    },
    async onSubmit(data) {
      this.expose_hideDialog();
      this.formOptions?.onSubmit(data);
    },
    expose_hideDialog() {
      this.btnRelateDialogVisible = false;
    },
    formatterWidthOrHeightStyle(length) {
      if (typeof length === "string") length = length.trim();
      if (/^\d+$/.test(length)) {
        return `${length}px`;
      } else if (/^\d+(%|px)?$/.test(length)) {
        return length;
      } else {
        console.warn("输入的高度或者宽度格式不正确！");
        return "";
      }
    },
  },
};
</script>
